import { render, staticRenderFns } from "./LexinKeyboardLangMya.vue?vue&type=template&id=17c95d9c&"
import script from "./LexinKeyboardLangMya.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangMya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports